package org.teddapp.project.ui.nav

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.teddapp.project.ui.TeddTokens
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.semantics.Role
import org.teddapp.project.ui.TeddSpace
import org.teddapp.project.ui.TeddTab
import org.teddapp.project.ui.TeddTabs
import org.teddapp.project.ui.TeddType
import org.teddapp.project.ui.teddCardShadow
import org.teddapp.project.ui.teddClickable

/**
 * Le pilier Objectifs a trois onglets : Objectifs, Projets et Compétences — ce que je vise,
 * ce que je mène, ce que j'apprends. Les trois écrans restent distincts dans le code ; ce
 * segment en tête fait passer de l'un à l'autre et la navigation n'en montre qu'une entrée.
 */
@Composable
fun PillarTabs(current: Section, onNavigate: (Section) -> Unit, compact: Boolean, modifier: Modifier = Modifier) {
    val sections = listOf(Section.Objectives, Section.Projects, Section.Skills)
    if (!compact) {
        TeddTabs(
            tabs = sections.map { TeddTab(it.name, it.label) },
            selected = current.name,
            onSelect = { name -> sections.firstOrNull { it.name == name && it != current }?.let(onNavigate) },
            modifier = modifier.padding(start = TeddSpace.S8, top = TeddSpace.S4),
        )
        return
    }
    // Sur téléphone, les trois onglets se partagent la largeur.
    val shape = RoundedCornerShape(TeddTokens.RSm)
    Row(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp)
            .background(TeddTokens.SurfaceSunken, RoundedCornerShape(TeddTokens.RSm + 3.dp))
            .padding(3.dp),
        horizontalArrangement = Arrangement.spacedBy(2.dp),
    ) {
        sections.forEach { section ->
            val selected = section == current
            Box(
                modifier = Modifier
                    .weight(1f)
                    .then(if (selected) Modifier.teddCardShadow(shape) else Modifier)
                    .teddClickable(
                        onClick = { if (!selected) onNavigate(section) },
                        shape = shape,
                        fill = if (selected) TeddTokens.Surface else Color.Transparent,
                        hover = if (selected) TeddTokens.Surface else Color.Transparent,
                        role = Role.Tab,
                    )
                    .height(32.dp),
                contentAlignment = Alignment.Center,
            ) {
                Text(
                    text = section.label,
                    color = if (selected) TeddTokens.Ink else TeddTokens.InkMuted,
                    style = TeddType.Label,
                    maxLines = 1,
                )
            }
        }
    }
}
